export type Theme = 'classic_blackboard' | 'dark_blackboard' | 'whiteboard';
export type Tool = 'chalk' | 'marker';

export interface Point {
  x: number;
  y: number;
  pressure: number; // 0..1
}

export interface BBox {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

export interface Stroke {
  id: number;
  board_id: number;
  user_id: string;
  tool: Tool;
  color: string;
  size: number;
  points: Point[];
  bbox: BBox;
  created_at: string;
  erased_at: string | null;
  erased_by: string | null;
}

export interface Board {
  id: number;
  slug: string;
  name: string;
  theme: Theme;
  is_default: boolean;
  created_by: string;
  created_at: string;
  archived_at: string | null;
}

export interface User {
  id: string;
  username: string;
  display_name: string | null;
  color: string;
  is_admin: boolean;
  /** 禁画截止时间（ISO），null/过去时间 = 未禁 */
  banned_until?: string | null;
}

export interface PresenceEntry {
  user_id: string;
  display_name: string;
  /** 登录用户名（药丸账号），展示优先级：昵称 → 用户名 → id */
  username?: string | null;
  color: string;
}

export const CANVAS_MIN = -50_000;
export const CANVAS_MAX = 50_000;
export const TILE_SIZE = 2048;
